export const GET_ORDER_SETTINGS_ERROR = "redux_store:orders.error.get_settings";
export const UPDATE_ORDER_SETTINGS_ERROR = "redux_store:orders.error.update_settings";

export const GET_ORDER_SHIFTS_ERROR = "redux_store:orders.error.get_shifts";
export const ADD_ORDER_SHIFT_ERROR = "redux_store:orders.error.add_shift";
export const DELETE_ORDER_SHIFT_ERROR = "redux_store:orders.error.delete_shift";
export const UPDATE_ORDER_SHIFT_ERROR = "redux_store:orders.error.update_shift";

export const GET_ORDER_PRODUCTS_ERROR = "redux_store:orders.error.get_products";
export const ADD_ORDER_PRODUCT_ERROR = "redux_store:orders.error.add_product";
export const DELETE_ORDER_PRODUCT_ERROR = "redux_store:orders.error.delete_product";
export const UPDATE_ORDER_PRODUCT_ERROR = "redux_store:orders.error.update_product";

export const GET_ORDERS_ERROR = "redux_store:orders.error.get";
export const UPDATE_ORDER_ERROR = "redux_store:orders.error.update";
export const GET_NEW_ORDERS_ERROR = "redux_store:orders.error.get_new";

export const ACTIVATE_STRIPE_ERROR = "redux_store:orders.error.activate_stripe";
export const DEACTIVATE_STRIPE_ERROR = "redux_store:orders.error.deactivate_stripe";


// WEBPACK FOOTER //
// ./src/errors/orders.js